import moment from "moment";
import React, { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { FaCircleInfo } from "react-icons/fa6";
import { FiCalendar } from "react-icons/fi";
import { Link } from "react-router-dom";
import lgbtqIcon from '../../../../assets/images/lgbtq.png';
import LocateBed from "../../../../assets/images/locate-bed.svg";
import InputBox from "../../../../Components/Input";
import Loader from "../../../../Components/Loader";
import ModalDailog from "../../../../Components/Modal";
import RadioButton from "../../../../Components/RadioButton";
import { showToast } from "../../../../Components/ToastNotification";
import Tooltip from "../../../../Components/Tooltip";
import {
  Agency,
  AgencyResponses,
  disabilityAccessible,
  gendersServed,
  locationType,
  roomType,
  urbanRuralClassification
} from "../../../../type/Agency";
import { CloseReason, closeReasons } from "../../../../type/Response";
import { API_ENDPOINTS } from "../../../../utils/api";
import createAxiosInstance from "../../../../utils/axiosInstance";
import { formatDateTime } from "../../../../utils/formatters";
import { availabilityByResponse, formatUrl, isValidURL } from "../../../../utils/helper";
import { useFeature } from "../../../../hooks/useFeature";
type MyRequestContainerProps = {
  request: any,
  myShelter: Agency | null,
  agencies: any,
  agenciesById: any,
  getMyRequest: () => void;
  updateCachedCloseRequestId: (id: string | null) => void
}

const MyRequestContainer: React.FC<MyRequestContainerProps> = ({ request, myShelter, agencies, agenciesById, getMyRequest, updateCachedCloseRequestId }) => {
  const hasCollaboratives = useFeature("bedfinder:collaboratives");

  const axiosInstance = createAxiosInstance();

  const defaultValues = {
    reason: "" as CloseReason,
    other: "",
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues,
  });

  // show hide modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenSheltercc, ModalOpenSheltercc] = useState(false);
  const [agencyData, setAgencyData] = useState<any>({});
  const [isLoding, setIsLoding] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };
  const openModalCC = (agencyDetails: any) => {
    const groupId = Array.isArray(agencyDetails.groupId)
      ? agencyDetails.profile?.defaultGroupId || agencyDetails.groupId[0]
      : null;

    const { regionalSupporter, canAnswerRequest, canSendRequest } =
      agencyDetails.groupInfo?.find((groupInfo: any) => groupInfo?.groupId === groupId) || {};

    const data = {
      id: agencyDetails.id,
      data: agencyDetails,
      groupId: groupId,
      regionalSupporter: regionalSupporter,
      canAnswerRequest: canAnswerRequest,
      isReferral: !canAnswerRequest && canSendRequest,
      city: ((agencyDetails.details?.city || "").split(",")[0] || "").trim(),
      state: (
        agencyDetails.details?.state ||
        (agencyDetails.details?.city || "").split(",")[1] ||
        ""
      ).trim()
    };

    setAgencyData(data);
    ModalOpenSheltercc(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const closeModalSheltercc = () => {
    ModalOpenSheltercc(false);
  };

  //  radio button value checked
  const [selectedValue, setSelectedValue] = useState("");

  const tabs = [{
    id: 0,
    title: "Possible Beds",
    key: "possible"
  }, {
    id: 1,
    title: "No Beds Available",
    key: "no"
  }, {
    id: 2,
    title: "Response Pending",
    key: "null"
  }];

  // tab props
  const [activeTabs, setActiveTabs] = useState(0);

  const handleTabChange = (tabId: number) => {
    setActiveTabs(tabId);
  };

  const agencyResponses = agencies
    ?.filter(
      (agency: any) =>
        agency.groupInfo?.some(
          (currentInfo: any) =>
            request?.need?.groupId?.includes(currentInfo.groupId) &&
            currentInfo.canAnswerRequest &&
            currentInfo.groupId != myShelter?.agencyId,
        ),
    )
    .filter((agency: any) => agency.agencyId != myShelter?.agencyId)
    .reduce(
      (responses: any, agency: any) => {
        const responseWithAgency = request?.responses?.find(
          (it: any) => it.agencyId == agency?.agencyId,
        );
        const agencyResponse = responseWithAgency?.response;
        if (!agencyResponse) return responses;

        (agencyResponse === "no"
          ? responses.no
          : agencyResponse === "null"
            ? responses.null
            : responses.possible
        ).push({
          availability:
            availabilityByResponse[responseWithAgency?.response] || null,
          agencyDetails: agenciesById[agency?.agencyId],
          modifiedAt: responseWithAgency?.modifiedAt,
        });

        return responses;
      },
      { possible: [], no: [], null: [] } as AgencyResponses,
    );

  const closeRequestHandler: SubmitHandler<any> = async (formData) => {
    try {
      setIsLoding(true);
      updateCachedCloseRequestId(request.requestId);
      const closeRequestPayload: any = {
        request: {
          reason: formData.reason,
        },
        status: "closed"
      };

      if (formData.reason === "other") {
        closeRequestPayload.request.other = formData.other;
      }

      const closeRequest = await axiosInstance.put(
        API_ENDPOINTS.BEDFINDER.CLOSEREQUEST.replace(
          "{requestId}",
          request.requestId
        ),
        closeRequestPayload
      );

      const closeNeedPayload: any = {
        status: "closed",
      };

      const closeNeed = await axiosInstance.put(
        API_ENDPOINTS.BEDFINDER.CLOSENEED.replace(
          "{needId}",
          request.needId
        ),
        closeNeedPayload
      );

      if (closeRequest.status === 200 && closeNeed.status === 200) {
        getMyRequest();
        closeModal();
        setIsLoding(false);
        showToast("The request was successfully closed.", "success");
      }
    } catch (error) {
      updateCachedCloseRequestId(null);
      setIsLoding(false);
      showToast("An error occurred while submitting the request. Please try again.", "error");
      console.log(error);
    }
  };

  return (
    <>
      {isLoding && <Loader />}
      <div key={request.requestId} className="card p-0 mt-6 overflow-hidden">
        {/* Card Header */}
        <div className="card-header flex flex-wrap gap-3 items-center justify-between p-5 border border-b text-gray-600 text-sm 2xl:text-base font-medium">
          <div className="flex flex-col md:flex-row gap-3 md:gap-4 md:items-center">
            <div className="flex items-center gap-3">
              <img src={LocateBed} alt="LocateBed" className="w-8" />
              <h3>
                Case reference #:{" "}
                <Link to={`/bedfinder/my-requests/review/${request.requestId}`} className="text-primary ms-1 underline font-semibold">
                  {request.need?.caseReferenceId}
                </Link>
              </h3>
            </div>
            <span className="text-blue-100 hidden md:block">|</span>
            <div>
              Request #:{" "}
              <Link to={`/bedfinder/my-requests/review/${request.requestId}`} className="text-primary underline font-semibold">
                {request.nr}
              </Link>
            </div>
          </div>
          <div className="flex items-center">
            <FiCalendar className="me-3" size={20} />
            <span>{formatDateTime(request.createdAt)}</span>
          </div>
        </div>

        {/* Card Body */}
        <div className="card-body p-3 lg:p-5">
          {/* Tab Navigation */}
          <div className="flex flex-wrap justify-between items-center">
            <div className="flex border border-borderGray rounded-lg mb-5 md:w-fit shadow-sm overflow-hidden">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`p-2 text-xs lg:w-44 2xl:w-48 justify-center border-r border-borderGray last:border-r-0 md:text-sm font-medium flex items-center gap-1 md:gap-2 ${activeTabs === tab.id
                    ? "bg-gray-100 text-gray-800"
                    : "text-gray-600 hover:text-gray-800"
                    }`}
                  onClick={() => handleTabChange(tab.id)}
                >
                  {tab.title}
                  {agencyResponses[tab.key]?.length > 0 && (
                    <span className={`min-w-6 w-6 h-6 flex justify-center items-center rounded-3xl  ${tab.id === 0 ? "bg-success text-white" : tab.id === 1 ? "bg-white border border-gray-400 text-gray-600" : "bg-white border border-gray-400 text-gray-600"}`}>
                      {agencyResponses[tab.key]?.length}
                    </span>
                  )}
                </button>
              ))}
            </div>
            <button className="btn-sm btn-error h-fit mb-5" onClick={openModal}>Close Request</button>
          </div>
          {/* Tab Content */}
          <div className="tab-content">
            {tabs.map((tab) => (
              <div
                key={tab.id}
                className={`tab-pane ${activeTabs === tab.id ? "block" : "hidden"}`}
              >
                {agencyResponses[tab.key]?.length > 0 && (
                  <div className="relative md:overflow-hidden md:border md:border-borderGray rounded-xl">
                    <table className="table_responsive_block w-full text-xs 2xl:text-sm text-left rtl:text-right">
                      <thead className="text-sm text-gray-600 bg-gray-50 border-b">
                        <tr>
                          <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Agency</th>
                          {activeTabs === 0 && <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Availability</th>}
                          <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Response Date</th>
                          <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">City</th>
                          <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">State</th>
                          <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Email</th>
                          <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Phone Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        {agencyResponses[tab.key]?.map((responseItem: any) => (
                          <tr className="bg-white border-b" key={responseItem?.agencyDetails?.agencyId}>
                            {hasCollaboratives ? (
                              <td data-title='Agency' scope="row" className="px-4 2xl:px-6 py-3 font-medium text-primary cursor-pointer whitespace-nowrap" onClick={() => openModalCC(responseItem?.agencyDetails)}>
                                {responseItem?.agencyDetails?.name ?? ""}
                              </td>
                            ) : (
                              <td data-title='Agency' scope="row" className="px-4 2xl:px-6 py-3 font-medium whitespace-nowrap">
                                {responseItem?.agencyDetails?.name ?? ""}
                              </td>
                            )}
                            {activeTabs === 0 && (
                              <td data-title='Availability' className="px-4 2xl:px-6 py-3">{responseItem?.availability}</td>
                            )}
                            <td data-title='Response Date' className="px-4 2xl:px-6 py-3">{activeTabs == 2 ? "-" : formatDateTime(responseItem?.modifiedAt)}</td>
                            <td data-title='City' className="px-4 2xl:px-6 py-3">{responseItem?.agencyDetails?.details?.city ?? ""}</td>
                            <td data-title='State' className="px-4 2xl:px-6 py-3">{responseItem?.agencyDetails?.details?.state ?? ""}</td>
                            <td data-title='Email' className="px-4 2xl:px-6 py-3"><span className='truncate'> {responseItem?.agencyDetails?.details?.referral?.email ?? ""}</span></td>
                            <td data-title='Phone Number' className="px-4 2xl:px-6 py-3">{responseItem?.agencyDetails?.details?.referral?.phone ?? ""}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {agencyResponses[tab.key]?.length === 0 && activeTabs === 0 && (
                  <div>List of available beds for this case.</div>
                )}
                {agencyResponses[tab.key]?.length === 0 && activeTabs === 1 && (
                  <div>Currently, no beds are available.</div>
                )}
                {agencyResponses[tab.key]?.length === 0 && activeTabs === 2 && (
                  <div>No response from the shelter yet.</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <ModalDailog isOpen={isModalOpen} handleSubmit={handleSubmit} closeRequest={closeRequestHandler} onClose={closeModal} title="Close Request" backButton="Go Back" primaryButton="Close This Request">
        <div className="card-header flex flex-col sm:flex-row sm:items-center gap-3 sm:justify-between mb-5 text-gray-600 text-base font-medium">
          <div className="flex flex-wrap gap-3 items-center">
            <div className="flex items-center items-center gap-3">
              <img src={LocateBed} alt="LocateBed" className="w-8" />
              <h3>
                Case reference #:{" "}
                <Link to="/" className="text-primary ms-3 font-semibold">
                  {request.need?.caseReferenceId}
                </Link>
              </h3>
            </div>
            <span className="text-blue-100 hidden sm:block">|</span>
            <div>
              Request #:{" "}
              <Link to="/" className="text-primary font-semibold">
                {request.nr}
              </Link>
            </div>
          </div>
          <div className="flex items-center">
            <FiCalendar className="me-3" size={20} />
            <span>{formatDateTime(request.createdAt)}</span>
          </div>
        </div>
        <h4 className="text-gray-950 text-lg font-semibold">Why are you closing this request?</h4>
        <div className="radio-groups mt-5">
          {errors?.reason && (
            <label className="text-error">This field is required.</label>
          )}
          {closeReasons.map((reason) => (
            <RadioButton
              key={reason}
              label={reason} value={reason}
              selectedValue={selectedValue}
              radioClass="mb-3"
              {...register("reason", { required: true })}
            />
          ))}
          <RadioButton
            key="other"
            label="Other" value="other"
            selectedValue={selectedValue}
            radioClass="mb-3"
            {...register("reason", { required: true })}
          />
          <InputBox
            type="text"
            inputClass={"sm:w-1/2 xl:w-1/3"}
            placeholder="Please add other"
            {...register("other", {
              maxLength: 150,
              required: watch("reason") === "other",
              disabled: watch("reason") !== "other",
            })}
          />
          {errors.other?.type === "required" && (
            <label className="text-error">
              Please fill out this field.
            </label>
          )}
          {errors.other?.type === "maxLength" && (
            <label className="text-error">Text field too long.</label>
          )}
        </div>
      </ModalDailog>

      <ModalDailog isOpen={isModalOpenSheltercc} onClose={closeModalSheltercc} title={agencyData?.data?.name} isFooterAvailable={false}>
        <div className="card-header flex items-center justify-between mb-5 text-gray-600 font-medium">
          <div className="flex flex-wrap space-x-4">
            {agencyData.isReferral && (
              <span className="py-1 px-3 rounded-full text-secondary 2xl:text-sm bg-blue-100">Referral Only</span>
            )}
            {agencyData.canAnswerRequest && (
              <span className="py-1 px-3 rounded-full text-white 2xl:text-sm bg-primary">Shelter</span>
            )}
            {agencyData.regionalSupporter && (
              <span className="py-1 px-3 rounded-full text-white 2xl:text-sm bg-secondary">Regional Supporter</span>
            )}
          </div>
          {agencyData?.data?.profile?.memberSince != "__private__" && (
            <div className="flex items-center">
              <FiCalendar className="me-3" size={20} />
              <span className="text-sm 2xl:text-base">Member since{" "}
                {moment(agencyData?.data?.profile?.memberSince || agencyData?.data?.createdAt).format(
                  "MMMM YYYY",
                )}
              </span>
            </div>
          )}
        </div>
        <div className="flex text-sm 2xl:text-base">
          <div className="md:w-1/3">
            <p className="text-dark mb-3">Location info:</p>
            <p className="text-gray-600">
              {agencyData.city}
              {agencyData.state ? ", " + agencyData.state : ""}
            </p>
            {agencyData?.data?.profile?.county != "__private__" && (
              <p>{agencyData?.data?.profile?.county}</p>
            )}
          </div>
          {agencyData?.canAnswerRequest && (
            <div className="md:w-1/3">
              <p className="text-dark mb-3">About the shelter:</p>
              <Referral agency={agencyData.data} />
              <GendersServed agency={agencyData.data} />
              <RoomType agency={agencyData.data} />
              <AdaCompliant agency={agencyData.data} />
              <DisabilityAccessible agency={agencyData.data} />
              <PublicTransportation agency={agencyData.data} />
              <UrbanRuralClassification agency={agencyData.data} />
              <LocationType agency={agencyData.data} />
              <LGBTQFriendly agency={agencyData.data} isModal={isModalOpenSheltercc} />
              <ShelterInformationForthcoming agency={agencyData.data} />
            </div>
          )}
          {agencyData?.data?.profile?.website && isValidURL(agencyData.data.profile.website) && (
            <div className="md:w-1/3 mb-3 md:mb-0">
              <p className="text-dark font-medium mb-2 md:mb-3">Website</p>
              {agencyData.data?.profile.website != "__private__" && (
                <a href={formatUrl(agencyData.data?.profile.website)} target="_blank" className="text-primary font-semibold break-words">
                  {agencyData.data?.profile.website}
                </a>
              )}
            </div>
          )}
        </div>

      </ModalDailog>
    </>
  );
};

interface Props {
  agency: Agency;
  isModal?: boolean;
}

const Referral: React.FC<Props> = ({ agency }) => {
  return agency.profile.referral ? <p>Referral agency only</p> : null;
};

const GendersServed: React.FC<Props> = ({ agency }) => {
  return agency.profile.gendersServed &&
    agency.profile.gendersServed !== "__private__" ?
    <p>{gendersServed[agency.profile.gendersServed]}</p> : null
}

const RoomType: React.FC<Props> = ({ agency }) => {
  return agency.profile.roomType &&
    agency.profile.roomType !== "__private__" ?
    <p>{roomType[agency.profile.roomType]}</p> : null
}

const AdaCompliant: React.FC<Props> = ({ agency }) => {
  return agency.profile.adaCompliant &&
    agency.profile.adaCompliant !== "__private__" &&
    !agency.profile.disabilityAccessible ?
    <p>{!agency.profile.adaCompliant ? "Not " : ""}ADA compliant</p> : null
}

const DisabilityAccessible: React.FC<Props> = ({ agency }) => {
  return agency.profile.disabilityAccessible &&
    agency.profile.disabilityAccessible !== "__private__" ?
    <p>{disabilityAccessible[`${agency.profile.disabilityAccessible}`]}</p> : null
}

const PublicTransportation: React.FC<Props> = ({ agency }) => {
  return agency.profile.publicTransportation &&
    agency.profile.publicTransportation !== "__private__" ?
    <p>
      {agency.profile.publicTransportation ? "Near" : "No nearby"} public
      transportation
    </p> : null
}

const UrbanRuralClassification: React.FC<Props> = ({ agency }) => {
  return agency.profile.urbanRuralClassification &&
    agency.profile.urbanRuralClassification !== "__private__" ?
    <p>{urbanRuralClassification[agency.profile.urbanRuralClassification]}</p> : null
}

const LocationType: React.FC<Props> = ({ agency }) => {
  return agency.profile.locationType &&
    agency.profile.locationType !== "__private__" ?
    <p>{locationType[agency.profile.locationType]}</p> : null
}

const LGBTQFriendly: React.FC<Props> = ({ agency, isModal }) => {

  const tooltipText = `Shelters responded Yes to at least one of the following questions:
          <br />* Does your organization provide tailored services and programs
          to people who identify as LGBTQ?
          <br />* Does your agency in general identify as an LGBTQ ally?`;

  return agency.profile.lgbtqFriendly !== "__private__" &&
    agency.profile.lgbtqFriendly ? (

    <p>
      <span id="lgbtq" className=""></span>
      <span className="flex items-center gap-1"><img src={lgbtqIcon} alt="lgbtqIcon" width={'25px'} /> LGBTQ friendly&nbsp;  <Tooltip text={tooltipText}><span className="cursor-pointer"><FaCircleInfo size="16" className="text-gray-600" /></span></Tooltip></span>
      <a className="popover-link" role="button">
        <span
          data-tooltip-id={
            isModal ? "modal-tooltip-" : "normal-tooltip-" + agency.agencyId
          }
          className="glyphicon glyphicon-info-sign tooltip-icon info"
        />
      </a>
    </p>
  ) : null
}

const ShelterInformationForthcoming: React.FC<Props> = ({ agency }) => {
  return !(
    (agency.profile.gendersServed &&
      agency.profile.gendersServed !== "__private__") ||
    (agency.profile.roomType && agency.profile.roomType !== "__private__") ||
    (agency.profile.adaCompliant &&
      agency.profile.adaCompliant !== "__private__") ||
    (agency.profile.disabilityAccessible &&
      agency.profile.disabilityAccessible !== "__private__") ||
    (agency.profile.publicTransportation &&
      agency.profile.publicTransportation !== "__private__") ||
    (agency.profile.urbanRuralClassification &&
      agency.profile.urbanRuralClassification !== "__private__") ||
    (agency.profile.locationType &&
      agency.profile.locationType !== "__private__") ||
    (agency.profile.lgbtqFriendly &&
      agency.profile.lgbtqFriendly !== "__private__") ||
    agency.profile.referral
  ) ? <p>Shelter information forthcoming.</p> : null;
}

export default MyRequestContainer;